export default defineNuxtPlugin(() => {
  const { appName, buildVersion, buildTime } = useRuntimeConfig().public
  console.log(`[${appName || 'biblestudy.by'}] v${buildVersion} built ${buildTime}`)
})
